import React from 'react'

export default function services() {
  return (
    <div className="site-section mt-5 pt-5 pb-5">
    <div className="container">
      <div className="row mb-5 justify-content-center">
        <div className="col-12 text-center">
          <h2 className="font-weight-light text-black display-4">Nos services</h2>
        </div>
        <div className="col-md-7 text-center">
          <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Cum iusto eaque qui illo cumque officia nobis assumenda odit perferendis ipsam dolore.</p>
        </div>
      </div>
      <div className="row no-gutters align-items-stretch h-100">
        <div className="col-lg-6">
          <div className="row no-gutters align-items-stretch h-100 half-sm">
            <div className="col-sm-12 col-md-6 col-6 bg-image bg-sm-height aos-init img-fluid" style={{backgroundImage:"url('/img1.webp')"}} data-aos="fade" data-aos-delay="0"></div>
            <div className="col-sm-12 col-md-6 col-6 bg-light text">
              <div className="p-4">
                <h2 className="h5 mb-3 text-black line-height-sm">Automative Manufacturing</h2>
                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. In ipsum error perspiciatis odit ullam officia. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Laudantium voluptatum vel natus, repellat at optio.</p>
                <p className="mb-0"><a href="#" className="btn btn-danger"><small className="text-uppercase font-weight-bold text-white">Read More</small></a></p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="row no-gutters align-items-stretch h-100 half-sm">
            <div className="col-sm-12 col-md-6   col-6 bg-image order-md-2 order-lg-1 bg-sm-height aos-init img-fluid" style={{backgroundImage: "url('/img2.webp')" }} data-aos="fade" data-aos-delay="200"></div>
            <div className="col-sm-12 col-md-6   col-6 bg-light text order-md-1 order-lg-2">
              <div className="p-4">
                <h2 className="h5 mb-3 text-black line-height-sm">Mechanical Engineering</h2>
                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. In ipsum error perspiciatis odit ullam officia. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aperiam, cupiditate officia recusandae velit sint totam.</p>
                <p className="mb-0"><a href="#" className="btn btn-danger"><small className="text-uppercase font-weight-bold text-white">Read More</small></a></p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="row no-gutters align-items-stretch h-100 half-sm">
            <div className="col-sm-12 col-md-6  col-6 bg-image order-md-1 order-lg-2 bg-sm-height aos-init img-fluid" style={{backgroundImage: "url('/img3.webp')"}} data-aos="fade" data-aos-delay="300"></div>
            <div className="col-sm-12 col-md-6  col-6 bg-light text order-md-2 order-lg-1">
              <div className="p-4">
                <h2 className="h5 mb-3 text-black line-height-sm">Oil &amp; Gas Energy</h2>
                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. In ipsum error perspiciatis odit ullam officia. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Alias fugiat facilis quasi ratione ducimus ipsam!</p>
                <p className="mb-0"><a href="#" className="btn btn-danger"><small className="text-uppercase font-weight-bold text-white">Read More</small></a></p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="row no-gutters align-items-stretch h-100 half-sm">
            <div className="col-sm-12 col-md-6   col-6 bg-image order-md-2 bg-sm-height aos-init img-fluid" style={{backgroundImage: "url('/img4.webp')" }} data-aos="fade" data-aos-delay="400"></div>
            <div className="col-sm-12 col-md-6  col-6 bg-light text order-md-1">
              <div className="p-4">
                <h2 className="h5 mb-3 text-black line-height-sm">Industrial Construction</h2>
                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. In ipsum error perspiciatis odit ullam officia. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Laudantium ullam est alias minus, expedita autem.</p>
                <p className="mb-0"><a href="#" className="btn btn-danger"><small className="text-uppercase font-weight-bold text-white">Read More</small></a></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  )
}
